import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { RouterLink } from 'APP/router/constants';
import { navigateTo } from 'APP/router/refs/navigateTo';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class SpaceDelete extends GroupsEvent {
  process() {
    const { spaceId } = this.eventPayload;
    const isSpaceOpened =
      Entities.spacesStore.activeSpaceId === spaceId && !Entities.GroupsStore.activeGroup;

    Tasks.space.removeSpaceLocally(spaceId);

    if (isSpaceOpened) {
      navigateTo({ to: RouterLink.Main });
      Tasks.app.showAlert(t('space_is_not_accessible'));
    }
  }
}
